import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import actionCreators from './verify2FAActionCreators';
import actions from './verify2FAActions';

import { useInterval } from '../../lib/reactHelpers/hooks';
import Verify2FA from './verify2FA';

const mapStateToProps = (state) => ({ ...state.verify2FA });

/**
 *
 * @deprecated
 * @see `cs/components/verify2FA/new/NewVerify2FA.tsx`
 */
const Verify2FAContainer = (props) => {
    const [secondsLeft, setSecondsLeft] = useState(props.secondsLeft);
    const dispatch = useDispatch();

    useEffect(() => {
        setSecondsLeft(props.secondsLeft);
    }, [props.secondsLeft]);

    useEffect(() => {
        if (secondsLeft === 0) {
            dispatch({ type: actions.VERIFY_2FA_FORM__CLEAR_SECONDS });
        }
    }, [secondsLeft]);

    useInterval(
        () => {
            if (!secondsLeft) {
                return;
            }

            setSecondsLeft(secondsLeft - 1);
        },
        secondsLeft ? 1000 : null,
    );

    return <Verify2FA {...props} secondsLeft={secondsLeft} />;
};

Verify2FAContainer.propTypes = {
    code: PropTypes.string,
    errorMessage: PropTypes.string,
    isErrorResend: PropTypes.bool,
    onChangeCode: PropTypes.func.isRequired,
    onSubmitCode: PropTypes.func.isRequired,
    status: PropTypes.bool,
};

export default connect(mapStateToProps, actionCreators)(Verify2FAContainer);
